import { textes } from "./textes";

export const t = (langue, cle, valeurParDefaut) => {
  const cleLangue = textes[langue] ? langue : "fr";
  if (textes[cleLangue][cle] === undefined) return valeurParDefaut || cle;
  return textes[cleLangue][cle];
};
